import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { IProjectAttrs, IProjectAttrsResponse } from '../types/project'
import { ConvertType, convertCaseList } from '@/shared/utils/convertString'

export const fetchProjectAttrs = async (
  instituteCode: string | undefined,
  curriculumId: string,
) => {
  const res = await axios.get<IProjectAttrsResponse[]>(
    `${window.apiEndpoint}/course/v1/project-attrs?institute_code=${instituteCode}&institute_curriculum_id=${curriculumId}`,
  )
  return convertCaseList(res.data, ConvertType.CAMEL) as IProjectAttrs[]
}

export const useProjectAttrsQuery = (instituteCode: string | undefined, curriculumId: string) => {
  return useQuery({
    queryKey: ['project', instituteCode, curriculumId],
    queryFn: () => fetchProjectAttrs(instituteCode, curriculumId),
    retry: 0,
  })
}
